// PKT-0666 · what the DEPLOY says it can do, as opposed to what this user is.
//
// Distinct from lib/capabilities.ts, which answers "what may this ROLE see" from
// the role alone. This asks the server a question the browser cannot infer:
// whether SMS_AGENT_SEND_ENABLED is on. That flag decides whether a locator may
// text a client assigned to them, and before this it was invisible everywhere —
// which is why the composer ended up offering a Send the route refuses with 403.
import { fetchWithAuth } from "../lib/api";

interface VersionCapability {
  state?: string;
}
interface VersionResponse {
  capabilities?: Record<string, VersionCapability>;
}

/**
 * `true` / `false` when the deploy answers, `null` when we genuinely do not know
 * — an older backend without the registry entry, or an unreachable API.
 *
 * The three-state return is the point. Collapsing "unknown" into `false` would
 * hide working sends the moment the API hiccups; collapsing it into `true` would
 * put the 403 back. Callers must decide deliberately, and for an offer-a-button
 * decision the honest reading of `null` is "do not promise".
 */
export async function fetchAgentSendEnabled(): Promise<boolean | null> {
  try {
    const res = await fetchWithAuth<VersionResponse>("/version");
    const state = res?.capabilities?.agent_sms_send?.state;
    if (state === "enabled") return true;
    if (typeof state === "string" && state.length > 0) return false;
    return null;
  } catch {
    return null;
  }
}
